
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/web/why-choose-us",
      function () {
        return require("private-next-pages/web/why-choose-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/web/why-choose-us"])
      });
    }
  